/**
 * Best-effort request that asks the browser to reduce eviction risk for this
 * origin. Browsers may grant or deny it; it is never a backup guarantee.
 */
export async function requestPersistentStorage(
  storage: Pick<StorageManager, 'persist'> | undefined =
    globalThis.navigator?.storage,
): Promise<boolean> {
  if (!storage || typeof storage.persist !== 'function') return false;
  try {
    return await storage.persist();
  } catch {
    return false;
  }
}
